import { Link } from "@inertiajs/react";
import type { PageAudit } from "@/types";
import { formatDateTime } from "@/utils/formatters";

type Props = {
  audits: PageAudit[];
};

export default function PageAuditHistory({ audits }: Props) {
  return (
    <section className="card">
      <div className="card-body">
        <div className="mb-4">
          <h2 className="text-xl font-semibold text-gray-900">Audits</h2>
          <p className="text-sm text-gray-500">Past evaluations of this page</p>
        </div>

        {audits.length === 0 ? (
          <p className="rounded-lg border border-dashed border-gray-200 px-4 py-6 text-center text-sm text-gray-500">
            No audits yet.
          </p>
        ) : (
          <ul className="divide-y divide-gray-100">
            {audits.map((audit) => (
              <li key={audit.id} className="flex flex-col gap-1 py-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-900">{formatDateTime(audit.created_at)}</p>
                  <p className="text-sm text-gray-500">
                    {audit.source === "weekly_monitoring" ? "Weekly monitoring" : "On demand"}
                  </p>
                </div>
                <Link href={audit.audit_url} className="text-sm text-primary hover:underline">
                  View audit
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
